const MARKDOWN_HELP = `
# Value Mapping (값 매핑)

Value Mapping 기능을 사용하면 **특정 입력값을 미리 정의된 출력값으로 변환**할 수 있습니다.  
이 기능은 **데이터 변환, 코드 변환, 명칭 변환 등** 다양한 용도로 활용할 수 있습니다.

---

## 🛠 사용 방법

1. **입력값**: 변환할 값 (예: 코드 값, 키워드, 상태 등)
2. **매핑 테이블**: 입력값과 출력값의 1:1 대응 관계 설정
3. **출력값**: 입력값에 해당하는 변환 결과 반환

---

## 📌 예제 1: 상태 코드 변환
### 매핑 설정:
| 입력 값  | 출력 값       |
|----------|--------------|
| "NEW"    | "신규"       |
| "IN_PROGRESS" | "진행 중" |
| "COMPLETED" | "완료됨"   |
| "CANCELLED" | "취소됨"   |

### 입력값:
\`\`\`json
"IN_PROGRESS"
\`\`\`

### 결과:
\`\`\`json
"진행 중"
\`\`\`

---

## 📌 예제 2: 국가 코드 변환
### 매핑 설정:
| 입력 값 | 출력 값 |
|---------|---------|
| "US"    | "United States" |
| "KR"    | "South Korea"   |
| "JP"    | "Japan"         |
| "CN"    | "China"         |

### 입력값:
\`\`\`json
"KR"
\`\`\`

### 결과:
\`\`\`json
"South Korea"
\`\`\`

---

## 📌 예제 3: 고객 등급 변환
### 매핑 설정:
| 입력 값 | 출력 값  |
|---------|---------|
| "1"     | "VIP"   |
| "2"     | "Gold"  |
| "3"     | "Silver" |
| "4"     | "Bronze" |

### 입력값:
\`\`\`json
"3"
\`\`\`

### 결과:
\`\`\`json
"Silver"
\`\`\`

---

## ⚙ 설정 방법
1. **입력 값과 출력 값을 1:1로 매핑**합니다.  
   - 예: \`"NEW" → "신규"\`, \`"IN_PROGRESS" → "진행 중"\`  
2. **입력값이 매핑 테이블에 존재하는지 확인**합니다.  
3. **일치하는 값이 있으면 해당하는 출력값을 반환**합니다.  
4. **일치하는 값이 없을 경우 기본값을 설정할 수도 있습니다.** (예: "Unknown")

---

## 🔍 주요 특징
- **명확한 1:1 매핑 가능** (예: 코드 변환, 명칭 변환)
- **데이터 정규화 및 표준화 용이**
- **미리 정의된 값만 처리 가능 (예외 처리가 필요할 수 있음)**
- **일치하는 값이 없을 경우 기본값 설정 가능**

💡 **Value Mapping을 사용하여 데이터를 쉽고 직관적으로 변환하세요!**
`

export const ValueMapping = {
  name: 'value-mapping',
  label: 'Value Mapping',
  specifications: [
    {
      type: 'map',
      name: 'valueMappings',
      label: 'Value Mappings'
    }
  ],
  help: MARKDOWN_HELP
}
